import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import {withContext} from '../../custom/StateProvider';
import {API} from "../../../config";
import {Grid, TableFilterRow, TableHeaderRow, Table, PagingPanel} from "@devexpress/dx-react-grid-material-ui";
import {FilteringState, IntegratedFiltering, IntegratedSorting, SortingState, TableColumnResizing, PagingState, IntegratedPaging} from "@devexpress/dx-react-grid";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Utils from "../../custom/utils";
import {connect} from "react-redux";
import {FusePageSimple} from '@fuse';
import Typography from '@material-ui/core/Typography';
import {List, ListItem, ListItemText, Paper} from "@material-ui/core";
import DoubleBubble from './components/doubleBubble';
import AssessKYC from './components/assessKYC';
import DocumentStatus from "./components/documentStatus";
const db_utils = API.service('utils');

const headerHeight = 60;

const m = require('moment');

const styles = theme => ({
    heading1:{
        color:theme.colorPrimary
    },
    header:{
        backgroundColor:"#262933",
        padding:'18px',
        paddingTop:'17px',
        color:'white'
    },
    flex: {
      flex: 1,
    },
  root                    : {},
  avatar                  : {},
  layoutHeader            : {
    height   : headerHeight,
    minHeight: headerHeight
  },
  layoutContentCardWrapper: {
    padding      : 24,
    paddingBottom: 80
  },
  layoutLeftSidebar       : {
    width: '400px',
    marginBottom:'50px'
  },
  addButton               : {
    position: 'absolute',
    right: 12,
    bottom: 12,
    zIndex: 99
  },
  listItem:{
      width:'100%'
  },
  listDiv:{
      position:'relative',
      width:'100%'
  }

});

class Kyc extends Component {
    state = {
        investors: [],
        filtered: [],
        columnWidths: [
          { columnName: 'acc', width:185},
          { columnName: '_name', width:200},
          { columnName: '_email', width:240},
          { columnName: '_state', width:110},
          { columnName: '_email_v', width:45},
          { columnName: '_affiliate', width:90},
          { columnName: '_last_activity', width:80},
          { columnName: '_poid', width:55},
          { columnName: '_poad', width:55},
          { columnName: '_actions', width:90},
        ],
        pageSizes: [20,50, 100, 200, 0],
        view: 'all',
        viewLabel: 'All',
        icount: {
          "all":0,
          "registered":0,
          "verified":0,
          "doc_suitability":0,
          "doc_resub":0,
          "doc_rfp":0,
          "doc_aml":0,
          "approved_issues":0,
          "approved":0,
        }
    }

    fetchData = () => {
        const app = this;

        let query = {}

        if(this.props.user.affiliate !== null){
          console.log('wtf')
          query = {query:{_affiliate:this.props.user.affiliate}}
          console.log('query',query)
        }

        db_utils.find(query).then(inv =>{
            let master = [];

            let icount= {
              "all":0,
              "registered":0,
              "verified":0,
              "doc_suitability":0,
              "doc_resub":0,
              "doc_rfp":0,
              "doc_aml":0,
              "approved_issues":0,
              "approved":0,
            }

            inv.result.forEach((v,k) => {
                v.investor_state = Utils.returnState(v._states)[0];

              icount['all']++;

              if(v.investor_state === 'signedup'){
                icount['registered']++;
              }

              if(v.investor_state === 'verified'){
                icount['verified']++;
              }

              if(v.investor_state === 'uploaded' && (v.poid_status === 'Requires Attention' || v.poad_status === 'Requires Attention')){
                icount['doc_suitability']++;
              }

              if(v.investor_state === 'returned' && (v.poid_status === 'Requires Attention' || v.poad_status === 'Requires Attention' || v.poid_status === 'Not Accepted' || v.poad_status === 'Not Accepted')){
                icount['doc_resub']++;
              }

              if((v.investor_state === 'returned' || v.investor_state === 'uploaded') && (v.poid_status === 'Accepted' || v.poad_status === 'Accepted')){
                icount['doc_rfp']++;
              }

              if((v.investor_state === 'allowed') && (v.poid_status !== 'Approved' || v.poad_status !== 'Approved')){
                icount['approved_issues']++;
              }

              if((v.investor_state === 'allowed') && (v.poid_status === 'Approved' || v.poad_status === 'Approved')){
                icount['approved']++;
              }

                master.push(v);
            })

            app.props.context.update({
              kyc_investors: master,
            })

          app.setState({
            filtered: master,
            icount
          });

          console.log('master',master);
        }).catch(e=>{
            console.log('Error Loading:', e);
            app.setState({
                error:'Error: ' + e
            })
        })
    }

    investorState(state) {
        let InvStatus = Utils.returnState(state);
        return(
          <div className={'kyc-label ' + InvStatus[0]}>{InvStatus[1]}</div>
        )
    }

    componentDidMount = () => {
        this.fetchData();
        console.log('investor',this.props);
    }

    changeColumnWidths = (columnWidths) => {
      this.setState({ columnWidths });
    };

    componentWillReceiveProps(nextProps, nextContext) {
      if(this.props.context.kycUpdate === false && nextProps.context.kycUpdate === true){
        this.props.context.update({
          kycUpdate:false
        })

        this.fetchData();
      }
    }

  setView = (view,viewLabel,e) => {

      let filtered = [];
      this.props.context.kyc_investors.forEach((v,i)=>{
        if(view === 'all'){
          filtered.push(v);
        }

        if(view === 'registered'){
          if(v.investor_state === 'signedup'){
            filtered.push(v);
          }
        }

        if(view === 'verified'){
          if(v.investor_state === 'verified'){
            filtered.push(v);
          }
        }

        if(view === 'doc_suitability'){
          if(v.investor_state === 'uploaded' && (v.poid_status === 'Requires Attention' || v.poad_status === 'Requires Attention')){
            filtered.push(v);
          }
        }

        if(view === 'doc_resub'){
          if(v.investor_state === 'returned' && (v.poid_status === 'Requires Attention' || v.poad_status === 'Requires Attention' || v.poid_status === 'Not Accepted' || v.poad_status === 'Not Accepted')){
            filtered.push(v);
          }
        }

        if(view === 'doc_rfp'){
          if((v.investor_state === 'returned' || v.investor_state === 'uploaded') && (v.poid_status === 'Accepted' || v.poad_status === 'Accepted')){
            filtered.push(v);
          }
        }

        if(view === 'approved_issues'){
          if((v.investor_state === 'allowed') && (v.poid_status !== 'Approved' || v.poad_status !== 'Approved')){
            filtered.push(v);
          }
        }

        if(view === 'approved'){
          if((v.investor_state === 'allowed') && (v.poid_status === 'Approved' || v.poad_status === 'Approved')){
            filtered.push(v);
          }
        }

      })

      this.setState({
        view: view,
        viewLabel: viewLabel,
        filtered:filtered,
      })
    }



    render() {

        const {classes} = this.props;
        var y = new m();

        return (
          <FusePageSimple
            className={classes.root}
            classes={{
              root              : classes.layoutRoot,
              contentCardWrapper: classes.layoutContentCardWrapper,
              leftSidebar       : classes.layoutLeftSidebar,
              header            : classes.layoutHeader
            }}
            header={
              <div className={classNames("flex flex-1 flex-col sm:flex-row items-center justify-between p-24")}>
                <Typography variant="title" color="inherit" className={"flex-1"}>
                  KYC - {this.state.viewLabel}
                </Typography>
              </div>
            }
            content={
              <div className={'flex-1 p-12'} style={{position:'relative'}}>
                  {(this.props.context.kyc_investors !== false) &&
                    <Grid
                        rows={this.state.filtered}
                        columns={[
                            { name: 'acc', title: 'Account' },
                            { name: '_name', title: 'Name', getCellValue: row => (row._firstname ? row._firstname + ' ' + row._surname: undefined) },
                            { name: '_email', title: 'Email' },
                            { name: '_state', title: 'State', getCellValue: row => (row._states ? this.investorState(row._states): undefined) },
                            { name: '_affiliate', title: 'Agent'},
                            { name: '_last_activity', title: 'Last',getCellValue: row => ((row.poid ? ((m.duration(m(y).diff(row.poid_timestamp)).as('days') > m.duration(m(y).diff(row.poad_timestamp)).as('days'))) ? m.duration(m(y).diff(row.poid_timestamp)).as('days').toFixed(0) + 'd' : m.duration(m(y).diff(row.poad_timestamp)).as('days').toFixed(0) + 'd': ''))},
                            { name: '_email_v', title: 'Verified', getCellValue: row => ((row._states & 2) ? <FontAwesomeIcon style={{color:'green'}} icon="check-circle" /> : <FontAwesomeIcon style={{color:'red'}} icon="times-circle" />)},
                            { name: '_poid', title: 'ID', getCellValue: row => ((row.poid) ? <DocumentStatus date={m(row.poid_timestamp).format('DD MMM')} status={row.poid_status} /> : null)},
                            { name: '_poad', title: 'Add', getCellValue: row => ((row.poad) ? <DocumentStatus date={m(row.poad_timestamp).format('DD MMM')} status={row.poad_status} /> : null)},
                            { name: '_actions', title: '', getCellValue: row => (<AssessKYC investor={row} />) },
                        ]}>

                      {/* name: '_actions', title: 'Actions', getCellValue: row => (<ViewInvestorButton row={row}/>) */}
                          <SortingState
                            defaultSorting={[{ columnName: '_timestamp', direction: 'desc' }]}
                          />
                          <IntegratedSorting />
                          <FilteringState defaultFilters={[]} />
                          <IntegratedFiltering />
                          <PagingState
                            defaultCurrentPage={0}
                            defaultPageSize={20}
                          />
                          <IntegratedPaging />
                          <Table />
                          <TableColumnResizing defaultColumnWidths={this.state.columnWidths} />
                          <TableHeaderRow showSortingControls />
                          <TableFilterRow />
                          <PagingPanel
                            pageSizes={this.state.pageSizes}
                          />
                      </Grid>
                    }
              </div>
              }

            leftSidebarContent={
              <div className={classNames(classes.root, "lg:p-24 lg:pr-4")}>
                <Paper className={'flex-1'} style={{position:'relative'}}>
                  <List>
                    <ListItem
                      button
                      onClick={()=>this.setView('all','All')}
                      activeClassName="active"
                      className={classes.listItem}>

                      <div className={classes.listDiv}>
                        <ListItemText primary="All" disableTypography={true}/>
                        <DoubleBubble main={this.state.icount['all']} alt={false} bg={'#5cb85c'} fg={'#ffffff'}/>
                      </div>
                    </ListItem>

                    <ListItem
                      button
                      onClick={()=>this.setView('registered','Registered')}
                      activeClassName="active"
                      className={classes.listItem}
                    >
                      <div className={classes.listDiv}>
                        <ListItemText primary="Registered" disableTypography={true}/>
                        <DoubleBubble main={this.state.icount['registered']} alt={false} bg={'#000000'} fg={'#ffffff'}/>
                      </div>
                    </ListItem>
                    <ListItem
                      button
                      onClick={()=>this.setView('verified','Email Verified')}
                      activeClassName="active"
                      className={classes.listItem}
                    >
                      <div className={classes.listDiv}>
                        <ListItemText primary="Email Verified" disableTypography={true}/>
                        <DoubleBubble main={this.state.icount['verified']} alt={false} bg={'#008293'} fg={'#ffffff'}/>
                      </div>
                    </ListItem>
                    <ListItem
                      button
                      onClick={()=>this.setView('doc_suitability','KYC Document Suitability')}
                      activeClassName="active"
                      className={classes.listItem}
                    >
                      <div className={classes.listDiv}>
                        <ListItemText primary="KYC Document Suitability" disableTypography={true}/>
                        <DoubleBubble main={this.state.icount['doc_suitability']} alt={false} bg={'#f0ad4e'} fg={'#ffffff'}/>
                      </div>
                    </ListItem>
                    <ListItem
                      button
                      onClick={()=>this.setView('doc_resub','KYC Document Resubmission')}
                      activeClassName="active"
                      className={classes.listItem}
                    >
                      <div className={classes.listDiv}>
                        <ListItemText primary="KYC Doc Resubmission" disableTypography={true}/>
                        <DoubleBubble main={this.state.icount['doc_resub']} alt={false} bg={'#d9534f'} fg={'#ffffff'}/>
                      </div>
                    </ListItem>
                    <ListItem
                      button
                      onClick={()=>this.setView('doc_rfp','KYC Ready for Process')}
                      activeClassName="active"
                      className={classes.listItem}
                    >
                      <div className={classes.listDiv}>
                        <ListItemText primary="KYC Ready for Process" disableTypography={true}/>
                        <DoubleBubble main={this.state.icount['doc_rfp']} alt={false} bg={'#f0ad4e'} fg={'#ffffff'}/>
                      </div>
                    </ListItem>
                    <ListItem
                      button
                      onClick={()=>this.setView('doc_aml','AML/PEP')}
                      activeClassName="active"
                      className={classes.listItem}
                    >
                      <div className={classes.listDiv}>
                        <ListItemText primary="AML/PEP" disableTypography={true}/>
                        <DoubleBubble main={this.state.icount['doc_aml']} alt={false} bg={'#008293'} fg={'#ffffff'}/>
                      </div>
                    </ListItem>
                    <ListItem
                      button
                      onClick={()=>this.setView('approved_issues','Trading Approved Doc Re-assessment')}
                      activeClassName="active"
                      className={classes.listItem}
                    >
                      <div className={classes.listDiv}>
                        <ListItemText primary="Approved w/ Doc Re-assessment" disableTypography={true}/>
                        <DoubleBubble main={this.state.icount['approved_issues']} alt={false} bg={'#f0ad4e'} fg={'#ffffff'}/>
                      </div>
                    </ListItem>

                    <ListItem
                      button
                      onClick={()=>this.setView('approved','Trading Approved')}
                      activeClassName="active"
                      className={classes.listItem}
                    >
                      <div className={classes.listDiv}>
                        <ListItemText primary="Trading Approved" disableTypography={true}/>
                        <DoubleBubble main={this.state.icount['approved']} alt={false} bg={'#5cb85c'} fg={'#ffffff'}/>
                      </div>
                    </ListItem>
                  </List>
                </Paper>
              </div>
            }

            sidebarInner

            onRef={instance => {
              this.pageLayout = instance;
            }}

            />
        );
    }
}

function mapStateToProps({ fuse, auth }) {
  return {
    user: auth.user
  }
}

export default withContext(withStyles(styles,{withTheme:true})(withRouter(connect(mapStateToProps)(Kyc))));
